import { ChevronRight } from 'lucide-react'

export function PosUserTypePermissions() {
  return (
    <details className="group pt-1">
      <summary className="cursor-pointer select-none font-medium text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 transition-colors list-none flex items-center gap-1.5">
        <ChevronRight className="w-4 h-4 transition-transform group-open:rotate-90" />
        Expand to review POS User Type Permissions
      </summary>
      <div className="mt-3 pl-5.5 space-y-3">
        <p>
          A <strong className="font-semibold">POS User Type</strong> defines a permissions level for
          Users of the POS System. The following User Types are available:
        </p>
        <p className="font-medium italic">Super User Permissions</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Log into any Location on the POS System</li>
          <li>Start a Regular Audit for a Location</li>
          <li>All Permissions Listed below</li>
        </ul>
        <p className="font-medium italic">District Manager Permissions</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Log into Locations assigned to a District</li>
          <li>Start a Regular Audit for a Location</li>
          <li>Product Price Override with ID and PIN</li>
          <li>All Permissions Listed below</li>
        </ul>
        <p className="font-medium italic">Store Manager Permissions</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Log into assigned Location</li>
          <li>Tax Removal Override with ID and Pin</li>
          <li>Open/Close Register</li>
          <li>Withdraw Cash from Register</li>
          <li>Create/Edit POS Store/Temp Clerks</li>
          <li>Open Location</li>
          <li>Start Final Audit and Close Location</li>
          <li>Manage Location Inventory</li>
          <li>Reprint Register Close Receipts</li>
          <li>Manage products for Quick Tab (Frequently Purchased Items)</li>
          <li>Full Data Update (Provision) for Register</li>
          <li>Repair Printer Connection</li>
          <li>All Permissions Listed below</li>
        </ul>
        <p className="font-medium italic">Store Clerks and Temp Clerks Permissions</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Log into assigned Location</li>
          <li>Recall Last Sale</li>
          <li>Submit products once Audit or Final Audit has started</li>
          <li>Process Sales and Returns</li>
        </ul>
      </div>
    </details>
  )
}
